var _rect, _rect2, _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "#f1f5f9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 72,
    width: 208,
    height: 176,
    rx: 14,
    fill: "#e2e8f0",
    stroke: "#cbd5e1",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 134,
    r: 20,
    fill: "#cbd5e1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 224l52-52 34 34 24-24 46 42H82z",
    fill: "#94a3b8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 282,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fill: "#64748b"
  }, "\r\n    No Image\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlaceholder);
export default __webpack_public_path__ + "static/media/product-placeholder.7488f16f9ddb4a8f8dd387188d549ca4.svg";
export { ForwardRef as ReactComponent };